<template>
  <va-card title="FAQ">
    <div class="separation-anxiety-faq-card-content">
      <div  v-for="(section, i) in faq.sections" :key="i">
        <div class="faq-sub-section-heading">{{section.heading}}</div>
        <ol>
          <div v-for="(info,index) in section.questions" :key="index">
            <li class="question">
              {{ info.question }}
            </li>
            <span>
              {{ info.answer }}
            </span>
          </div>
        </ol>
      </div>
    </div>
  </va-card>
</template>

<script>
import separationAnxietyFAQ from '../../data/separation-anxiety-faq.json'

export default {
  name: 'separation-anxiety-faq-card',
  data () {
    return {
      faq: separationAnxietyFAQ.faq,
    }
  },
}
</script>

<style scoped lang="scss">
  .separation-anxiety-faq-card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: small;

    .faq-sub-section-heading {
      font-weight: bold;
      font-size: medium;
      margin: 8px 0;
    }

    ol {
      margin-left: 2rem;

      li {
        list-style: number;
        font-weight: bold;
      }
    }
  }
</style>
